import { MessageSquareIcon, PencilIcon, ShieldIcon, TicketIcon, UserMinusIcon, UserPlusIcon } from "lucide-react";

import type { ApiNotificationType } from "@/features/notifications/types";

export const TYPE_CONFIG: Record<ApiNotificationType, { icon: React.ElementType; iconClass: string; bgClass: string; label: string }> = {
  ProjectInvitation: {
    icon: UserPlusIcon,
    iconClass: "text-primary",
    bgClass: "bg-primary/10",
    label: "Project invite",
  },
  ProjectRemoval: {
    icon: UserMinusIcon,
    iconClass: "text-destructive",
    bgClass: "bg-destructive/10",
    label: "Removed from project",
  },
  ProjectRoleUpdate: {
    icon: ShieldIcon,
    iconClass: "text-amber-600 dark:text-amber-400",
    bgClass: "bg-amber-500/10",
    label: "Role updated",
  },
  TicketAssignment: {
    icon: TicketIcon,
    iconClass: "text-primary",
    bgClass: "bg-primary/10",
    label: "Ticket assigned",
  },
  TicketUpdate: {
    icon: PencilIcon,
    iconClass: "text-amber-600 dark:text-amber-400",
    bgClass: "bg-amber-500/10",
    label: "Ticket updated",
  },
  CommentReply: {
    icon: MessageSquareIcon,
    iconClass: "text-primary",
    bgClass: "bg-primary/10",
    label: "Comment reply",
  },
};

export const INVITE_STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  Pending: { label: "Pending", className: "text-amber-600 dark:text-amber-400" },
  Accepted: { label: "Accepted", className: "text-primary" },
  Declined: { label: "Declined", className: "text-muted-foreground" },
  Expired: { label: "Expired", className: "text-muted-foreground" },
};
